module.exports = __webpack_public_path__ + "static/media/003_iOS - 3 - SIGN IN text state.5fe8af9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/003_iOS - 3 - SIGN IN text state.png
// module id = 500
// module chunks = 0